import React from "react";
import ministImage from "../assets/images/ios/FEHK4P0N.webp";
import eventryImage from "../assets/images/ios/S8D9HJOZ.webp";
import unitConverterImage from "../assets/images/ios/TC1W0L0T.webp";
import tipCalculatorImage from "../assets/images/ios/NQ35PA94.webp";
import cryptoTrackerImage from "../assets/images/websites/6CXFXIBN.webp";
import quizGeneratorImage from "../assets/images/websites/CHBTRH02.webp";
import sortingVisualizerImage from "../assets/images/websites/JJGKIDWA.webp";
import asteroidsGameImage from "../assets/images/games/NNLNMG2M.webp";
import hexagonsGameImage from "../assets/images/games/5RQUN0TI.webp";
import blocksGameImage from "../assets/images/games/KDOCQVN3.webp";
import Project from "./project/Project";
import "./Projects.css";

const Projects = () => {
  return (
    <>
      <div className="projects-section">
        <Project
          image={ministImage}
          title="Minist"
          repository="minist"
          demoLink="https://apps.apple.com/us/app/minist/id6670408459"
        />
        <Project
          image={eventryImage}
          title="Eventry"
          repository="eventry"
          demoLink="https://apps.apple.com/us/app/eventry/id6742124798"
        />
        <Project
          image={unitConverterImage}
          title="Unit Converter"
          repository="unit-converter"
          demoLink="https://apps.apple.com/fi/app/ultimate-unit-converter-pro/id6463096286"
        />
        <Project
          image={tipCalculatorImage}
          title="Tip Calculator"
          demoLink="https://apps.apple.com/us/app/ultimate-tip-calculator-pro/id6504262579"
        />
        <Project
          image={sortingVisualizerImage}
          title="Sorting Visualizer"
          repository="sorting-visualizer"
        />
        <Project
          image={cryptoTrackerImage}
          title="Crypto Tracker"
          repository="crypto-tracker"
        />
        <Project
          image={quizGeneratorImage}
          title="Quiz Generator"
          repository="quiz-generator"
        />
        <Project
          image={asteroidsGameImage}
          title="Asteroids Game"
          repository="asteroids-game"
        />
        <Project
          image={blocksGameImage}
          title="Blocks Game"
          repository="blocks-game"
          type="game"
        />
        <Project
          image={hexagonsGameImage}
          title="Hexagons Game"
          repository="hexagons-game"
        />
      </div>
    </>
  );
};

export default Projects;
